/**
 * Search params wspólne dla całego lejka: UTM-y i znaczniki kliknięć z reklamy, wariant A/B (`v`),
 * krok do wznowienia (`step`), widok kalendarza (`widok`), wybrany slot (`start`), zmiana terminu (`zmiana`).
 * Walidacja ręczna zamiast Zoda: kilka opcjonalnych stringów nie uzasadnia Zoda classic w głównym chunku (ADR-1).
 */
const KEYS = {
  utm_source: 100,
  utm_medium: 100,
  utm_campaign: 200,
  utm_content: 200,
  utm_term: 200,
  gclid: 200,
  fbclid: 200,
  utm_device: 100,
  /** Google Ads tracking template params used by Tutlo's campaigns (HubSpot + umawiator fields). */
  hsa_ad: 200,
  hsa_cam: 200,
  hsa_grp: 200,
  hsa_kw: 200,
  hsa_mt: 200,
  hsa_src: 200,
  hsa_tgt: 200,
  v: 32,
  step: 64,
  widok: 16,
  start: 40,
  /** id rezerwacji przekładanej z poczekalni (`/kalendarz?zmiana=`) */
  zmiana: 40,
  /** id Spotkania z linku w mailu (`/s/:token?k=`), zdejmowane z paska po odtworzeniu sesji */
  k: 64,
} as const

export type Search = { -readonly [K in keyof typeof KEYS]?: string }

export function validateSearch(raw: Record<string, unknown>): Search {
  const out: Search = {}
  for (const key of Object.keys(KEYS) as Array<keyof typeof KEYS>) {
    // TanStack Router parses search values as JSON, so `?k=62159135290` or `?utm_campaign=2026`
    // arrive as numbers; they are opaque strings for us.
    const raw_ = raw[key]
    const value = typeof raw_ === 'number' && Number.isFinite(raw_) ? String(raw_) : raw_
    if (typeof value === 'string' && value.length > 0 && value.length <= KEYS[key]) out[key] = value
  }
  return out
}

/** UTM-y z search params w kształcie `createLeadBody.utm`. */
export function utmFromSearch(search: Search) {
  const utm: Record<string, string> = {}
  if (search.utm_source) utm.source = search.utm_source
  if (search.utm_medium) utm.medium = search.utm_medium
  if (search.utm_campaign) utm.campaign = search.utm_campaign
  if (search.utm_content) utm.content = search.utm_content
  if (search.utm_term) utm.term = search.utm_term
  if (search.utm_device) utm.device = search.utm_device
  if (search.gclid) utm.gclid = search.gclid
  if (search.fbclid) utm.fbclid = search.fbclid
  for (const key of [
    'hsa_ad',
    'hsa_cam',
    'hsa_grp',
    'hsa_kw',
    'hsa_mt',
    'hsa_src',
    'hsa_tgt',
  ] as const) {
    const value = search[key]
    if (value) utm[key] = value
  }
  return utm
}
